<template>
  <div class="fb-plus-free-callout">
    <!-- expander -->
    <div
      class="expander"
      role="button"
      tabindex="0"
      :aria-expanded="isExpanded"
      :aria-controls="accessibilityId"
      @click="toggleExpanded"
      @keyup.enter.self="toggleExpanded"
    >
      <div class="">
        <plus-free-access-countdown
          v-if="!isExpanded"
          :show-countdown="false"
          :remaining-days="plusFreeAccess.remainingDays"
          :remaining-hours="plusFreeAccess.remainingHours"
        />
      </div>

      <icon-button
        class="-ico-only -no-container"
        :icon="!isExpanded ? 'expand_more' : 'expand_less'"
        :label="!isExpanded ? 'Expand' : 'Collapse'"
      />
    </div>

    <!-- content -->
    <div
      :id="accessibilityId"
      class="callout-content"
      :class="{ '-hidden': !isExpanded }"
      :aria-hidden="!isExpanded"
    >
      <div
        class=""
        role="button"
        tabindex="0"
        :aria-expanded="isExpanded"
        :aria-controls="accessibilityId"
        @click="toggleExpanded"
        @keyup.enter="toggleExpanded"
      >
        <plus-free-access-countdown
          :show-countdown="isExpanded"
          :remaining-days="plusFreeAccess.remainingDays"
          :remaining-hours="plusFreeAccess.remainingHours"
        />
      </div>

      <div v-if="hasTour" class="action">
        <icon-button
          class="-txt-only -dark -no-case"
          :reduce="false"
          :label="startTourText"
          @click-action="forceStartTour"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Collapsible callout to show fb plus feature and load a tour when the site is in plus free access mode.
 */
import { ref, computed } from 'vue'
import { useUserAuthStore } from '@/stores/user-auth'
import { useToursStore } from '@/stores/tours'
import { cachePut, cacheGet, cacheRemove } from '@/utils/local-storage-cache'
import IconButton from '@/components/buttons/icon-button.vue'
import PlusFreeAccessCountdown from '@/components/notifications/plus-free-access-countdown.vue'
import { storeToRefs } from 'pinia'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    tourId?: string
    startTourText?: string
  }>(),
  {
    tourId: '',
    startTourText: 'See What you Can do with Plus',
  },
)

/** NON REACTIVE **/
const accessibilityId = 'plus-free-callout-content'
const cacheKey = 'plus-free-callout'

/** STATE **/
const userAuthStore = useUserAuthStore()
const { loadTour } = useToursStore()
const { plusFreeAccess } = storeToRefs(userAuthStore)
const isExpanded = ref(cacheGet({ key: cacheKey, defaultValue: true }))

/** COMPUTED **/
const hasTour = computed(() => !!(props.tourId && userAuthStore.user.isLoggedIn))

/** METHODS **/
function toggleExpanded() {
  console.log('toggleExpanded')
  isExpanded.value = !isExpanded.value

  if (!isExpanded.value) {
    // track user closed
    const twoWeeksInSeconds = 14 * 24 * 60 * 60
    cachePut({ key: cacheKey, value: false, ttl: twoWeeksInSeconds })
  } else {
    // if user expands, remove cache
    cacheRemove(cacheKey)
  }
}

function forceStartTour() {
  console.log('forceStartTour', props.tourId)
  if (props.tourId) {
    loadTour({ tourId: props.tourId, force: true })
  }
}
</script>
